<template>
  <ResolutionOptionCardShell
    data-qa="express-replace-option"
    data-test="express-replace-option"
    :icon="IconExpressReplacement"
    :option-type="RESOLUTION_OPTION_TYPE_ENUM.expressReplace"
    @select="handleSelect"
  >
    <template #title>
      {{ i18n(translations.title)
      }}<sup class="text-static-default-mid -top-[1em] text-[0.6rem]">BETA</sup>
    </template>

    <template #kicker>
      {{ i18n(translations.kicker) }}
    </template>

    <template #description>
      {{ i18n(translations.description) }}
    </template>

    <template #tags>
      <RevTag :label="i18n(translations.tag)" variant="info" />
    </template>

    <template #price>
      <div class="md:mb-8 md:mt-16 lg:mb-8 lg:mt-16">
        {{ i18n(translations.price) }}
      </div>
    </template>
  </ResolutionOptionCardShell>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import { RESOLUTION_OPTION_TYPE_ENUM } from '@backmarket/http-api/src/api-specs-resolution-engine/types/common'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevTag } from '@ds/components/Tag'
import { IconExpressReplacement } from '@ds/icons/IconExpressReplacement'

import ResolutionOptionCardShell from '../ResolutionOptionCardShell/ResolutionOptionCardShell.vue'

import translations from './ExpressReplaceResolutionOptionCard.translations'

const emit = defineEmits<{
  select: [value: string]
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const route = useRoute()

function handleSelect(event: string) {
  trackClick({
    name: RESOLUTION_OPTION_TYPE_ENUM.expressReplace,
    page_type: 'resolution_options',
    zone: 'resolution_flow',
    orderline_id: route.params.orderlineId,
  })
  emit('select', event)
}
</script>
